<p class="content1" [innerHTML]="description | safeHtml"></p>
<p class="content1" [innerHTML]="descriptionWarranty | safeHtml"></p>